export * from './objekte-filter.component';
export * from './objekte-filter.component.module';